import { SurveyConfig, GenesysConfig } from '../../types/global';

export const generateSurveyLink = (chatId: string, agentName: string, surveyConfig: SurveyConfig, genesysConfig: GenesysConfig) => {
    const params = new URLSearchParams();
    const unixTime = Math.floor(Date.now() / 1000);

    params.append('platformName', surveyConfig.platformName);
    params.append('tenantName', surveyConfig.tenantName);
    params.append('surveyName', surveyConfig.surveyName);
    params.append('customerId', genesysConfig.emailAddress);
    params.append('interactionID', chatId);
    params.append('interactionTime', unixTime.toString());
    params.append('agent', agentName);
    params.append('language', surveyConfig.language);
    params.append('clientName', surveyConfig.clientName);
    params.append('brand', surveyConfig.brand);

    const queryString = params.toString();
    return (`${surveyConfig.baseApiUrl}/create?${queryString}`);
}